type PhysicalAddressLike = {
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  postalCode?: string | null;
  stateProvince?: string | null;
  stateProvinceShort?: string | null;
};

/**
 * Street on the first line, then "City, ST ZIP". Empty parts are dropped.
 */
export function getAddressLines(
  physicalAddress: PhysicalAddressLike | null | undefined
): string[] {
  if (!physicalAddress) {
    return [];
  }

  const street = [physicalAddress.address1, physicalAddress.address2]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(', ');

  const state = (physicalAddress.stateProvinceShort || physicalAddress.stateProvince)?.trim();
  const cityStateZip = [
    physicalAddress.city?.trim(),
    [state, physicalAddress.postalCode?.trim()].filter(Boolean).join(' '),
  ]
    .filter(Boolean)
    .join(', ');

  return [street, cityStateZip].filter(Boolean);
}
